module.exports = __webpack_public_path__ + "img/bannershow.0018a47a.png";